import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import type { EnrollFormData } from "./types";
import type { EnrollmentQuestion } from "@/types/enrollment-questionnaire";

interface Props {
  questions: EnrollmentQuestion[];
  form: EnrollFormData;
  updateField: <K extends keyof EnrollFormData>(
    key: K,
    value: EnrollFormData[K]
  ) => void;
}

const MAX_LEN = 5000;
const MIN_LEN = 1;

export function StepQuestionnaire({ questions, form, updateField }: Props) {
  function setAnswer(questionId: string, value: string) {
    updateField("questionnaireAnswers", {
      ...form.questionnaireAnswers,
      [questionId]: value,
    });
  }

  return (
    <div className="space-y-6">
      {questions.map((q, idx) => {
        const answer = form.questionnaireAnswers[q.id] ?? "";
        const inputId = `questionnaire-${q.id}`;
        return (
          <div key={q.id} className="space-y-2">
            <Label htmlFor={inputId} className="items-baseline gap-2">
              <span
                className="font-heading text-[13px] italic tabular-nums leading-none text-primary/70"
                style={{ fontFamily: "var(--font-heading)" }}
              >
                {String(idx + 1).padStart(2, "0")}
              </span>
              <span className="text-sm font-medium leading-snug text-foreground">
                {q.prompt}
                <span className="ml-1 text-rose-500">*</span>
              </span>
            </Label>
            <Textarea
              id={inputId}
              value={answer}
              onChange={(e) => setAnswer(q.id, e.target.value)}
              placeholder="Vaš odgovor..."
              rows={5}
              maxLength={MAX_LEN}
              className="resize-none"
            />
            <div className="flex items-center justify-between text-xs text-muted-foreground">
              <span>Min. {MIN_LEN} karakter</span>
              <span className="tabular-nums">
                {answer.length}/{MAX_LEN}
              </span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
